(function($, undefined) {
	'use strict';
	var formValidator;
	var utils;
	
	var init = function() {
		formValidator = Fw.component.models().form;
		utils = Fw.component.models().utils;
		
		$('#account-info-form').on('submit', onAccountInfoFormSubmit);
		$('#account-password-form').on('submit', onAccountPasswordFormSubmit);
	};
	
	function onAccountInfoFormSubmit(e) {
		e.preventDefault();
		var form = $(e.currentTarget);
		formValidator.validateForm(form);
		$('.form-message_success', form).hide();
		
		if (!form.hasClass('has-error')) {
			var fields = $.map($('input, select:visible', form), (item) => item.name);
			var values = $.map($('input, select:visible', form), (item) => item.value);
			utils.updatePersonFields(fields, values, null, (response) => {
				if (response.indexOf('success') !== -1) {
					$('.form-message_success', form).slideDown(300);
				}
			});
		}
		
		return false;
	}
	
	function onAccountPasswordFormSubmit(e) {
		e.preventDefault();
		var form = $(e.currentTarget);
		formValidator.validateForm(form);
		var passwordValid = formValidator.validatePasswordRestrictions($('[name=password]', form).val());
		$('.form-message_error.wrong-password', form).hide();
		$('.form-message_error.invalid-password', form).hide();
		$('.form-message_success', form).hide();
		
		if (!form.hasClass('has-error') && passwordValid) {
			var fields = ["currentPassword", "password"];
			var values = [$('[name=currentPassword]', form).val(), $('[name=password]', form).val()];
			utils.updatePersonFields(fields, values, null, (response) => {
				console.log(response);
				
				if (response.indexOf('success') !== -1) {
					$('.form-message_success', form).slideDown(300);
					form[0].reset();
				}
				else if (response.indexOf("wrong.password") !== -1) {
					$('.form-message_error.wrong-password', form).slideDown(300);
				}
			});
		} else {
			if (!passwordValid) {
				$('.form-message_error.invalid-password', form).slideDown(300);
			}
		}
		
		return false;
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
